export const bloodGroups=['A+','A-','B+','B-','AB+','AB-','0+','0-'];
export const validGender=value=>['kadın','erkek'].includes(value);
export const licences=['YOK','M','A1','A2','A','B1','B','BE','C1','C1E','C','CE','D1','D1E','D','DE','E','F','G'];
export function personalIssues(form){
 const issues={};
 if(!bloodGroups.includes(form.kanGrubu))issues.kanGrubu='bloodGroupRequired';
 if(!form.maasBeklenti?.trim())issues.maasBeklenti='salaryRequired';
 if(!form.ehliyet?.trim())issues.ehliyet='licenceRequired';
 if(!form.askerlikDurumu?.trim()||(form.tcVatandasiMi===true&&form.askerlikDurumu.trim().toLowerCase()==='uygulanmaz'))issues.askerlikDurumu='militaryRequired';
 if(!form.medeniDurumu?.trim())issues.medeniDurumu='maritalRequired';
 // false is a complete answer, not an empty selection.
 if(typeof form.seyahatDurumu!=='boolean')issues.seyahatDurumu='travelRequired';
 return issues;
}
export function identityIssues(form){
 const issues={};
 if(!form.adi?.trim())issues.adi='identityRequiredMessage';
 if(!form.soyadi?.trim())issues.soyadi='identityRequiredMessage';
 if(!validDate(form.dogumTarihi))issues.dogumTarihi='identityRequiredMessage';
 else if(form.dogumTarihi>(form.enYeniDogumTarihi||latestBirthDate()))issues.dogumTarihi='minimumAge';
 if(form.tcVatandasiMi===true&&!validTc(form.kimlikNo?.trim()))issues.kimlikNo='invalidTcMessage';
 if(form.tcVatandasiMi===false){
  if(!['NATIONAL_ID','PASSPORT'].includes(form.kimlikBelgeTuru))issues.kimlikBelgeTuru='foreignIdentityRequiredMessage';
  if(!form.kimlikNo?.trim()||form.kimlikNo.trim().length>50)issues.kimlikNo='foreignIdentityRequiredMessage';
 }
 if(!validGender(form.cinsiyet))issues.cinsiyet='genderRequired';
 return issues;
}
export function latestBirthDate(today) {
  const parts=today||new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Istanbul',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).filter(x=>x.type!=='literal').reduce((r,x)=>{r[x.type]=x.value;return r;},{});
  const date=typeof parts==='string'?parts:`${parts.year}-${parts.month}-${parts.day}`;
  const [year,month,day]=date.split('-').map(Number),target=year-16;
  const lastDay=new Date(Date.UTC(target,month,0)).getUTCDate();
  return `${target}-${String(month).padStart(2,'0')}-${String(Math.min(day,lastDay)).padStart(2,'0')}`;
}
export function validDate(value){return /^\d{4}-\d{2}-\d{2}$/.test(value||'')&&Number(value.slice(0,4))>=1900&&!isNaN(Date.parse(value))&&new Date(value+'T00:00:00Z').toISOString().slice(0,10)===value;}
export function validTc(value){
  if(!/^[1-9]\d{10}$/.test(value||''))return false;
  const digits=Array.from(value,Number),odd=digits[0]+digits[2]+digits[4]+digits[6]+digits[8],even=digits[1]+digits[3]+digits[5]+digits[7];
  return ((odd*7-even)%10+10)%10===digits[9]&&digits.slice(0,10).reduce((a,b)=>a+b,0)%10===digits[10];
}
export function identityError(form){
  if(!form.adi?.trim()||!form.soyadi?.trim()||!validDate(form.dogumTarihi))return 'identityRequiredMessage';
  if(form.dogumTarihi>(form.enYeniDogumTarihi||latestBirthDate()))return 'minimumAge';
  if(form.tcVatandasiMi===true&&!validTc(form.kimlikNo?.trim()))return 'invalidTcMessage';
  if(form.tcVatandasiMi===false&&(!form.kimlikNo?.trim()||form.kimlikNo.trim().length>50||!['NATIONAL_ID','PASSPORT'].includes(form.kimlikBelgeTuru)))return 'foreignIdentityRequiredMessage';
  if(!validGender(form.cinsiyet))return 'genderRequired';
  return null;
}
